<template>
  <div class="m_enterprise_siteinfo">
    <div class="site-info-option">
      <el-button v-permission="['112030201101002']" type="primary" :loading="loading" :disabled="loading" @click="submit">保 存</el-button>
    </div>
    <div class="site-info-tree-data">
      <um-table-role ref="UmTableRole" :tree-data="treeData" />
    </div>
  </div>
</template>
<script>
import { sysmodule_checked_tree, sysmodule_update_submit } from '@/api/manage.js'
import UmTableRole from '@/components/UmTableRole'

export default {
  name: 'SiteInfo',
  components: { UmTableRole },
  props: {
    orgUserUuid: {
      type: String,
      default: ''
    }
  },
  data() {
    // const _this = this
    return {
      loading: false,
      tree_id: 0,
      treeData: [],
      checkList: [],
      defaultProps: {
        children: 'children',
        label: 'sysModuleName',
        disabled: (data, node) => {
          return data.readOnly
        }
      }
    }
  },
  computed: {
    treeDataFilter() {
      if (this.treeData.length > 0) {
        return this.treeData[this.tree_id].children
      } else {
        return []
      }
    }
  },
  watch: {
  },
  created() {
    this.getTree()
  },
  methods: {
    init() {
      const list = []
      this.checkList = []
      function deep(list, newList) {
        list.forEach(item => {
          if (item.children && item.children.length > 0) {
            deep(item.children, newList)
          } else {
            if (item.checked) {
              newList.push(item.sysModuleCode)
            }
          }
        })
      }
      this.treeData.forEach(item => {
        const child = []
        if (item.children === undefined) {
          //
        } else {
          deep(item.children, child)
        }
        list.push(child)
      })
      this.checkList = list
      console.log(list)
    },
    getTree() {
      const load = this.$load()
      sysmodule_checked_tree({
        checkedUserUuid: this.orgUserUuid
      }).then(d => {
        this.treeData = d.data
        this.init()
        load.close()
      }).catch(e => {
        this.treeData = []
        this.checkList = []
        this.$errorHandle(e)
        load.close()
      })
    },
    async submit() {
      const load = this.$load()
      try {
        this.loading = true
        const res = await sysmodule_update_submit({
          checkedUserUuid: this.orgUserUuid,
          sysModuleCodeList: this.$refs.UmTableRole.getCheckData()
        })
        this.$message.success(res.msg)
      } catch (e) {

      } finally {
        this.loading = false
        load.close()
      }
    },
    submitBak() {
      const length = this.treeData.length
      const list = []
      for (let i = 0; i < length; i++) {
        let child = []
        child = child.concat(this.$refs[`tree_${i}`][0].getCheckedNodes().filter(item => {
          return !item.readOnly
        }))

        child = child.concat(this.$refs[`tree_${i}`][0].getHalfCheckedNodes().filter(item => {
          return !item.readOnly
        }))
        child = child.map(item => item.sysModuleCode)
        console.log(child)
        if (child.length > 0 && !this.treeData[i].readOnly) {
          child.push(this.treeData[i].sysModuleCode)
        }
        list.push(...child)
      }

      const load = this.$load()
      sysmodule_update_submit({
        checkedUserUuid: this.orgUserUuid,
        sysModuleCodeList: list
      }).then(d => {
        load.close()
        this.$message.success(d.msg)
      }).catch(e => {
        load.close()
        this.$errorHandle(e)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.m_enterprise_siteinfo{
  position: relative;
  display: flex;
  flex-direction: column;
  .site-info-option{
    position: absolute;
    top: -42px;
    right: 20px;
  }
  .site-info-tree-data{
    flex: 1;
    overflow-y: auto;
  }
}
</style>
